import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { CursorProvider } from './components/providers/Cursor';
import { BGColorProvider } from './components/providers/ColorContainer';
import { BrowserRouter } from 'react-router-dom';
import { registrarOrigen } from './cms/contactos';
import { iniciarCookies } from './cms/cookies';

// Al cargar, antes de cualquier redirección: las UTM de la primera página van con el contacto
registrarOrigen();
iniciarCookies();

const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
  <React.StrictMode>
    <CursorProvider>
      <BGColorProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </BGColorProvider>
    </CursorProvider>
  </React.StrictMode>
);
